import { render, staticRenderFns } from "./receiptRecord.vue?vue&type=template&id=633eeb5f"
import script from "./receiptRecord.vue?vue&type=script&lang=js"
export * from "./receiptRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports